export default __webpack_public_path__ + "static/media/header.c690d3cb.jpg";